import { Box, type SxProps, type Theme } from "@mui/material";
import { mergeSxProps } from "@src/appV2/lib";

export interface TagProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

/**
 * Tag component for displaying a tag with a background color and text color.
 * Style via sx and background / color
 */
export function Tag(props: TagProps) {
  const { children, sx } = props;

  return (
    <Box
      sx={mergeSxProps(
        (theme: Theme) => ({
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          paddingX: 2,
          paddingY: 1,
          fontSize: theme.typography.caption.fontSize,
          fontWeight: theme.typography.fontWeightMedium,
          borderRadius: theme.borderRadius?.small,
          color: theme.palette.text.invert,
        }),
        sx
      )}
    >
      {children}
    </Box>
  );
}
